import React from 'react';
import { Map, MapProps } from './map';
import { MapPlaceholder } from './placeholder';

export interface PlaceholderedMapProps extends MapProps {}
export const PlaceholderedMap: React.FC<PlaceholderedMapProps> = (props) =>
  props.center ? <Map {...props} /> : <MapPlaceholder {...props} />;
